import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { GuardsCheckStart, PRIMARY_OUTLET, Router, UrlTree } from '@angular/router';
import { UserService } from '@core/services/user.service';
import { filter } from 'rxjs';
import { GuestService } from './guest.service';

/** Ends the guest access as soon as the guest leaves the share link and its shared cases. */
export function provideGuestExit(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const router = inject(Router);
    const guestService = inject(GuestService);
    const userService = inject(UserService);

    // After redirects so `**` targets count as left, before guards so AuthGuard never sees the guest.
    router.events
      .pipe(filter((event) => event instanceof GuardsCheckStart))
      .subscribe(({ urlAfterRedirects }) => {
        if (!guestService.getAccessToken()) {
          return;
        }
        if (isGuestPage(router.parseUrl(urlAfterRedirects), guestService.getSharedIds())) {
          return;
        }
        guestService.clearGuestToken();
        if (userService.isGuest()) {
          userService.clearUser();
        }
      });
  });
}

function isGuestPage(url: UrlTree, sharedIds: string[]): boolean {
  const [page, id, ...rest] =
    url.root.children[PRIMARY_OUTLET]?.segments.map((segment) => segment.path) ?? [];
  if (page === 'shared') {
    return true;
  }
  return page === 'video-details' && !rest.length && sharedIds.includes(id);
}
